// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + {"360":"1d5a44ac86f75ece05b9","388":"d372785d649c335b5259","530":"e731dfce4b744a08dfa5","600":"97b03b60100c14b5c028","858":"61438cec2a830d1b49c2","928":"401d9c8392228f833aea","957":"2254a087add337c8e940","962":"d9766b6ec420c3c1b6e3"}[chunkId] + ".chunk.js";
};